// Author Lin
// Date 2024-06-11 14:17:58

class SithMesInventoryDeliveryTask {
    constructor({
                    id = null,
                    deliveryNo = '',
                    deliveryType = '',
                    proWbs = '',
                    prdPpHeaderId = '',
                    dnOrderId = '',
                    dnNumber = '',
                    inspectionStatus = '',
                    inspectionStation = '',
                    logisticsStatus = '',
                    packageNo = '',
                    isDisassembled = '',
                    exitPermitStatus = '',
                    shipper = '',
                    receiptCompany = '',
                    receiptAddress = '',
                    receiptPerson = '',
                    receiptPhoneNum = '',
                    attachment = '',
                    deliveryOperatorId = '',
                    remark = '',
                    attachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.deliveryNo = deliveryNo;
        this.deliveryType = deliveryType;
        this.proWbs = proWbs;
        this.prdPpHeaderId = prdPpHeaderId;
        this.dnOrderId = dnOrderId;
        this.dnNumber = dnNumber;
        this.inspectionStatus = inspectionStatus;
        this.inspectionStation = inspectionStation;
        this.logisticsStatus = logisticsStatus;
        this.packageNo = packageNo;
        this.isDisassembled = isDisassembled;
        this.exitPermitStatus = exitPermitStatus;
        this.shipper = shipper;
        this.receiptCompany = receiptCompany;
        this.receiptAddress = receiptAddress;
        this.receiptPerson = receiptPerson;
        this.receiptPhoneNum = receiptPhoneNum;
        this.attachment = attachment;
        this.deliveryOperatorId = deliveryOperatorId;
        this.remark = remark;
        this.attachmentList = attachmentList;
    }
}

function newEntity() {
    return new SithMesInventoryDeliveryTask();
}

const partsVoConfigs = [
    {
        key: 'deliveryNo',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryNo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryType',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.proWbs',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumber',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.wbsNumber',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machine1',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.machine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'logisticsStatus',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.logisticsStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '已申请'},
                {value: '2', text: '已核对接收'},
                {value: '3', text: '待包装'},
                {value: '4', text: '已退回'},
                {value: '5', text: '已包装'},
                {value: '6', text: '已盘点'},
                {value: '7', text: '已拆箱'},
                {value: '8', text: '已装车待发货'},
                {value: '9', text: '已发货'},
                {value: '10', text: '已通知库房点件'}
            ]
        }
    },
    {
        key: 'exitPermitStatus',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.exitPermitStatus',
        sortable: true,
        isDetail: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未提交申请'},
                {value: '2', text: '审批中'},
                {value: '3', text: '申请已通过'},
                {value: '4', text: '申请被驳回'}
            ]
        }
    },
    {
        key: 'shipper',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.shipper',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptCompany',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptAddress',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptAddress',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPerson',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptPerson',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPhoneNum',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptPhoneNum',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.attachmentList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperatorId',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryOperatorId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperator',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryOperator',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTime',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.createdTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]
const dn400VoConfigs = [
    {
        key: 'deliveryNo',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryNo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryType',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.proWbs',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumber',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.wbsNumber',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machine1',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.machine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dnNumber',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.dnNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dnPo',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.dnPo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'logisticsStatus',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.logisticsStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '已申请'},
                {value: '2', text: '已核对接收'},
                {value: '3', text: '待包装'},
                {value: '4', text: '已退回'},
                {value: '5', text: '已包装'},
                {value: '6', text: '已盘点'},
                {value: '7', text: '已拆箱'},
                {value: '8', text: '已装车待发货'},
                {value: '9', text: '已发货'},
                {value: '10', text: '已通知库房点件'}
            ]
        }
    },
    {
        key: 'exitPermitStatus',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.exitPermitStatus',
        sortable: true,
        isDetail: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未提交申请'},
                {value: '2', text: '审批中'},
                {value: '3', text: '申请已通过'},
                {value: '4', text: '申请被驳回'}
            ]
        }
    },
    {
        key: 'shipper',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.shipper',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptCompany',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptAddress',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptAddress',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPerson',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptPerson',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPhoneNum',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptPhoneNum',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.attachmentList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperatorId',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryOperatorId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperator',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryOperator',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTime',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.createdTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryNo',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryType',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '生产终检转交'},
                    {value: '2', text: '800工单转交'},
                    {value: '3', text: 'DN400点件转交'},
                    {value: '4', text: '其他转交'}
                ]
            }
        },
        {
            key: 'proWbs',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.proWbs',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsNumber',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.wbsNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'machine1',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.machine1',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdPpHeaderId',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.prdPpHeaderId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ppo',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.ppo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.materialDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dnOrderId',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.dnOrderId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dnNumber',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.dnNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dnPo',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.dnPo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectionStatus',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.inspectionStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '检验合格'},
                    {value: '2', text: '已提交检验'},
                    {value: '3', text: '未提交检验'},
                    {value: '4', text: '检验不合格'}
                ]
            }
        },
        {
            key: 'inspectionStation',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.inspectionStation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectionInitiator',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.inspectionInitiator',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectionInitiatorName',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.inspectionInitiatorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'logisticsStatus',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.logisticsStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '已申请'},
                    {value: '2', text: '已核对接收'},
                    {value: '3', text: '待包装'},
                    {value: '4', text: '已退回'},
                    {value: '5', text: '已包装'},
                    {value: '6', text: '已盘点'},
                    {value: '7', text: '已拆箱'},
                    {value: '8', text: '已装车待发货'},
                    {value: '9', text: '已发货'},
                    {value: '10', text: '已通知库房点件'}
                ]
            }
        },
        {
            key: 'isDisassembled',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.isDisassembled',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'exitPermitStatus',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.exitPermitStatus',
            sortable: true,
            isDetail: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '未提交申请'},
                    {value: '2', text: '审批中'},
                    {value: '3', text: '申请已通过'},
                    {value: '4', text: '申请被驳回'}
                ]
            }
        },
        {
            key: 'shipper',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.shipper',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receiptCompany',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptCompany',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receiptAddress',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptAddress',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receiptPerson',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptPerson',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receiptPhoneNum',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptPhoneNum',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.attachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryOperatorId',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryOperatorId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryOperator',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryOperator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const inspectionVoConfigs = [
    {
        key: 'deliveryNo',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryNo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryType',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.proWbs',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumber',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.wbsNumber',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machine1',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.machine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionStatus',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.inspectionStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '检验合格'},
                {value: '2', text: '已提交检验'},
                {value: '3', text: '未提交检验'},
                {value: '4', text: '检验不合格'}
            ]
        }
    },
    {
        key: 'inspectionStation',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.inspectionStation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionInitiatorName',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.inspectionInitiatorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'logisticsStatus',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.logisticsStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '已申请'},
                {value: '2', text: '已核对接收'},
                {value: '3', text: '待包装'},
                {value: '4', text: '已退回'},
                {value: '5', text: '已包装'},
                {value: '6', text: '已盘点'},
                {value: '7', text: '已拆箱'},
                {value: '8', text: '已装车待发货'},
                {value: '9', text: '已发货'},
                {value: '10', text: '已通知库房点件'}
            ]
        }
    },
    {
        key: 'isDisassembled',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.isDisassembled',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exitPermitStatus',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.exitPermitStatus',
        sortable: true,
        isDetail: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未提交申请'},
                {value: '2', text: '审批中'},
                {value: '3', text: '申请已通过'},
                {value: '4', text: '申请被驳回'}
            ]
        }
    },
    {
        key: 'shipper',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.shipper',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptCompany',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptAddress',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptAddress',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPerson',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptPerson',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPhoneNum',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptPhoneNum',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.attachmentList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperatorId',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryOperatorId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperator',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryOperator',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTime',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.createdTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]
const orderVoConfigs = [
    {
        key: 'deliveryNo',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryNo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryType',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.proWbs',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumber',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.wbsNumber',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machine1',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.machine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppo',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.ppo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.materialDescription',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'logisticsStatus',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.logisticsStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '已申请'},
                {value: '2', text: '已核对接收'},
                {value: '3', text: '待包装'},
                {value: '4', text: '已退回'},
                {value: '5', text: '已包装'},
                {value: '6', text: '已盘点'},
                {value: '7', text: '已拆箱'},
                {value: '8', text: '已装车待发货'},
                {value: '9', text: '已发货'},
                {value: '10', text: '已通知库房点件'}
            ]
        }
    },
    {
        key: 'exitPermitStatus',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.exitPermitStatus',
        sortable: true,
        isDetail: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未提交申请'},
                {value: '2', text: '审批中'},
                {value: '3', text: '申请已通过'},
                {value: '4', text: '申请被驳回'}
            ]
        }
    },
    {
        key: 'shipper',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.shipper',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptCompany',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptAddress',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptAddress',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPerson',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptPerson',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPhoneNum',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.receiptPhoneNum',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.attachmentList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperatorId',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryOperatorId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperator',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.deliveryOperator',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTime',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.grid.createdTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]

const filter = {
    idFilter: '',
    idListFilter: [],
    deliveryNoFilter: '',
    deliveryTypeFilter: '',
    proWbsFilter: '',
    prdPpHeaderIdFilter: '',
    dnOrderIdFilter: '',
    dnNumberFilter: '',
    inspectionStatusFilter: '',
    inspectionStationFilter: '',
    inspectionInitiatorFilter: '',
    logisticsStatusFilter: '',
    isDisassembledFilter: '',
    exitPermitStatusFilter: '',
    shipperFilter: '',
    receiptCompanyFilter: '',
    receiptAddressFilter: '',
    receiptPersonFilter: '',
    receiptPhoneNumFilter: '',
    deliveryOperatorIdFilter: '',
    deliveryOperatorFilter: '',
    packageNoFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'deliveryNoFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    },
    {
        key: 'proWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.proWbs',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'prdPpHeaderIdFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.prdPpHeaderId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
            , fieldsBindingByEntityModalSelected: '{"proWbs":"wbsCode"}'
        }
    },
    {
        key: 'dnNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.dnNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.inspectionStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '检验合格'},
                {value: '2', text: '已提交检验'},
                {value: '3', text: '未提交检验'},
                {value: '4', text: '检验不合格'}
            ]
        }
    },
    {
        key: 'logisticsStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.logisticsStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '已申请'},
                {value: '2', text: '已核对接收'},
                {value: '3', text: '待包装'},
                {value: '4', text: '已退回'},
                {value: '5', text: '已包装'},
                {value: '6', text: '已盘点'},
                {value: '7', text: '已拆箱'},
                {value: '8', text: '已装车待发货'},
                {value: '9', text: '已发货'},
                {value: '10', text: '已通知库房点件'}
            ]
        }
    },
    {
        key: 'isDisassembledFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.isDisassembled',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'shipperFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.shipper',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompanyFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.receiptCompany',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperatorFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryOperator',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"deliveryOperatorId":"id"}'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];
const partsFilterConfigs = [
    {
        key: 'deliveryNoFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'proWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.proWbs',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'logisticsStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.logisticsStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '已申请'},
                {value: '2', text: '已核对接收'},
                {value: '3', text: '待包装'},
                {value: '4', text: '已退回'},
                {value: '5', text: '已包装'},
                {value: '6', text: '已盘点'},
                {value: '7', text: '已拆箱'},
                {value: '8', text: '已装车待发货'},
                {value: '9', text: '已发货'},
                {value: '10', text: '已通知库房点件'}
            ]
        }
    },
    {
        key: 'shipperFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.shipper',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompanyFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.receiptCompany',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperatorFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryOperator',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"deliveryOperatorId":"id"}'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];
const dn400FilterConfigs = [
    {
        key: 'deliveryNoFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'proWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.proWbs',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'dnNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.dnNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'logisticsStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.logisticsStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '已申请'},
                {value: '2', text: '已核对接收'},
                {value: '3', text: '待包装'},
                {value: '4', text: '已退回'},
                {value: '5', text: '已包装'},
                {value: '6', text: '已盘点'},
                {value: '7', text: '已拆箱'},
                {value: '8', text: '已装车待发货'},
                {value: '9', text: '已发货'},
                {value: '10', text: '已通知库房点件'}
            ]
        }
    },
    {
        key: 'shipperFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.shipper',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompanyFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.receiptCompany',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperatorFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryOperator',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"deliveryOperatorId":"id"}'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];
const inspectionFilterConfigs = [
    {
        key: 'deliveryNoFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'proWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.proWbs',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'inspectionStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.inspectionStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '检验合格'},
                {value: '2', text: '已提交检验'},
                {value: '3', text: '未提交检验'},
                {value: '4', text: '检验不合格'}
            ]
        }
    },
    {
        key: 'logisticsStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.logisticsStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '已申请'},
                {value: '2', text: '已核对接收'},
                {value: '3', text: '待包装'},
                {value: '4', text: '已退回'},
                {value: '5', text: '已包装'},
                {value: '6', text: '已盘点'},
                {value: '7', text: '已拆箱'},
                {value: '8', text: '已装车待发货'},
                {value: '9', text: '已发货'},
                {value: '10', text: '已通知库房点件'}
            ]
        }
    },
    {
        key: 'isDisassembledFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.isDisassembled',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'shipperFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.shipper',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompanyFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.receiptCompany',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperatorFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryOperator',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"deliveryOperatorId":"id"}'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];
const orderFilterConfigs = [
    {
        key: 'deliveryNoFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'proWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.proWbs',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'prdPpHeaderIdFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.prdPpHeaderId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
            , fieldsBindingByEntityModalSelected: '{"proWbs":"wbsCode"}'
        }
    },
    {
        key: 'logisticsStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.logisticsStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '已申请'},
                {value: '2', text: '已核对接收'},
                {value: '3', text: '待包装'},
                {value: '4', text: '已退回'},
                {value: '5', text: '已包装'},
                {value: '6', text: '已盘点'},
                {value: '7', text: '已拆箱'},
                {value: '8', text: '已装车待发货'},
                {value: '9', text: '已发货'},
                {value: '10', text: '已通知库房点件'}
            ]
        }
    },
    {
        key: 'shipperFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.shipper',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompanyFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.receiptCompany',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryOperatorFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.deliveryOperator',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"deliveryOperatorId":"id"}'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const partsEntityConfigs = [
    {
        key: 'deliveryType',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.deliveryType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.proWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'shipper',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.shipper',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptCompany',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptAddress',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptAddress',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPerson',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptPerson',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPhoneNum',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptPhoneNum',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    },
]
const dn400EntityConfigs = [
    {
        key: 'deliveryType',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.deliveryType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.proWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'dnNumber',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.dnNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'shipper',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.shipper',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptCompany',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptAddress',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptAddress',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPerson',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptPerson',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPhoneNum',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptPhoneNum',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    },
]
const entityFormConfigs = [
    {
        key: 'deliveryType',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.deliveryType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.proWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'prdPpHeaderId',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.prdPpHeaderId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
            , fieldsBindingByEntityModalSelected: '{"proWbs":"wbsCode"}'
        }
    },
    {
        key: 'dnNumber',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.dnNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionStation',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.inspectionStation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isDisassembled',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.isDisassembled',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'shipper',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.shipper',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptCompany',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptAddress',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptAddress',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPerson',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptPerson',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPhoneNum',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptPhoneNum',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachment'
        }
    }
]
const inspectionEntityConfigs = [
    {
        key: 'deliveryType',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.deliveryType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.proWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'inspectionStation',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.inspectionStation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isDisassembled',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.isDisassembled',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'shipper',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.shipper',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptCompany',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptAddress',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptAddress',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPerson',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptPerson',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPhoneNum',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptPhoneNum',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    },
]
const orderEntityConfigs = [
    {
        key: 'deliveryType',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.deliveryType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.proWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'prdPpHeaderId',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.prdPpHeaderId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
            , fieldsBindingByEntityModalSelected: '{"proWbs":"wbsCode"}'
        }
    },
    {
        key: 'shipper',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.shipper',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptCompany',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptAddress',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptAddress',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPerson',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptPerson',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptPhoneNum',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.receiptPhoneNum',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryDeliveryTask.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    },
]

export {
    SithMesInventoryDeliveryTask, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs, partsFilterConfigs, dn400FilterConfigs, inspectionFilterConfigs, orderFilterConfigs
    , partsEntityConfigs, dn400EntityConfigs, inspectionEntityConfigs, orderEntityConfigs
    , partsVoConfigs, dn400VoConfigs, inspectionVoConfigs, orderVoConfigs
}
